import { Grid } from "@mui/material";
import React from "react";

import { useDeviceWidth } from "src/hooks";

type Props = {
  children: React.ReactNode;
};

export const LinksGrid = ({ children }: Props) => {
  const { isMobile } = useDeviceWidth();
  const childrenArray = React.Children.toArray(children);

  return (
    <Grid container spacing={5} sx={{ mt: isMobile ? 0 : 10 }}>
      {childrenArray.map((child, index) => (
        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
          {child}
        </Grid>
      ))}
    </Grid>
  );
};
